import endpoints from "../core/endpoints";
import request from "../core/request";
import { Platform } from "../types/constants";
import { FactoryPagination, Movie } from "../types/movie";

export const getFactories = async (reqData: {
  pageNumber: number;
  searchValue: string;
}): Promise<{ items: Movie[]; pagination: FactoryPagination }> => {
  // const platform: Platform = JSON.parse(Cookies.get("platform") || "{}");
  const platform: Platform = JSON.parse(localStorage.getItem('platform') || "{}")
  const {
    data: { message: movies },
  } = await request.get(
    endpoints.factory.list(reqData.pageNumber, platform.id, reqData.searchValue)
  );

  return {
    items: movies.items.data,
    pagination: movies.pagination,
  };
};

export const setMovieToFactory = async (reqData: { movieId: number }) => {
  const data = await request({
    url: endpoints.factory.isQC,
    method: "POST",
    data: {
      factory_movie_id: reqData.movieId,
      is_qc: false,
    },
  });

  return data;
};

export const ignoreMovie = async (reqData: { movieId: number }) => {
  const data = await request({
    url: endpoints.factory.isQC,
    method: "POST",
    data: {
      factory_movie_id: reqData.movieId,
      is_qc: true,
    },
  });

  return data;
};

export const getMovieSubtitle = async (reqData: { movieId: number }) => {
  const { data } = await request.get(
    endpoints.factory.getSubtitle(reqData.movieId)
  );

  return data?.attributes;
};
